import React from "react";
import { Button } from "@material-ui/core";

interface StyledActionButtonProps {
  label: string;
  loadingLabel?: string;
  onClick: () => void;
  disabled?: boolean;
  loading?: boolean;
  color: string;
  variant?: "contained" | "outlined" | "text";
  size?: "small" | "medium" | "large";
  fullWidth?: boolean;
  startIcon?: React.ReactNode;
}

const StyledActionButton: React.FC<StyledActionButtonProps> = ({
  label,
  loadingLabel,
  onClick,
  disabled = false,
  loading = false,
  color,
  variant = "contained",
  size = "large",
  fullWidth = false,
  startIcon,
}) => {
  const isDisabled = disabled || loading;
  const displayLabel = loading && loadingLabel ? loadingLabel : label;

  return (
    <Button
      variant={variant}
      size={size}
      onClick={onClick}
      disabled={isDisabled}
      fullWidth={fullWidth}
      startIcon={startIcon}
      style={{
        textTransform: "none",
        fontWeight: 600,
        borderRadius: 8,
        padding: size === "large" ? "12px 32px" : "8px 24px",
        fontSize: size === "large" ? 16 : 14,
        backgroundColor: variant === "contained" ? color : "transparent",
        color: variant === "contained" ? "#000" : color,
        border: variant === "outlined" ? `1px solid ${color}` : "none",
        boxShadow: variant === "contained" && !isDisabled ? `0 3px 10px ${color}40` : "none",
        opacity: isDisabled ? 0.45 : 1,
        transform: isDisabled ? "none" : undefined,
        transition: "all 0.3s ease",
      }}
      onMouseEnter={(e) => {
        if (!isDisabled && variant === "contained") {
          e.currentTarget.style.transform = "translateY(-2px)";
          e.currentTarget.style.boxShadow = `0 6px 16px ${color}50`;
        }
      }}
      onMouseLeave={(e) => {
        if (variant === "contained" && !isDisabled) {
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = `0 3px 10px ${color}40`;
        }
      }}
    >
      {displayLabel}
    </Button>
  );
};

export default StyledActionButton;
